// extracted by mini-css-extract-plugin
module.exports = {"lds-spinner":"Spinner_lds-spinner__leb_K"};